import { render } from "./Account.root.vue?vue&type=template&id=c0bb534a"
import script from "./Account.root.vue?vue&type=script&lang=js"
export * from "./Account.root.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__